(ns frontend.ui.component.lp-portal.report.body.real-estate.fund.hotel-v2.pdf
  
  (:require
   [clojure.string :as s]
   [common.util :as cu]
   [frontend.ui.component.chart.view :as chart-view]
   [frontend.ui.component.lp-portal.page.pdf.view :as page]
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.resi-v2.epc-table :as epc-table]
   [frontend.ui.component.lp-portal.report.component.horizontal-table.pdf-view :as horizontal-table-pdf]
   [frontend.ui.component.lp-portal.report.component.vertical-table.pdf-view :as vertical-table-pdf]
   [frontend.ui.component.lp-portal.text-content.pdf.view :as text-content]
   [frontend.ui.component.lp-portal.voima-components.pdf.card.view :as card]
   [frontend.ui.style.theme.core :as theme]
   [potpuri.core :as potpuri]
   [reagent.dom.server :as rs]))

(defn custom-title
  "Editor-renamed card title, falling back to the default. Clearing a title
   stores an empty string, so this tests blank rather than nil."
  [data data-key default-title]
  (let [stored (get-in data [data-key :custom-title])]
    (if (cu/blank-value? stored)
      default-title
      stored)))

(defn custom-optional-footer
  ([data]
   (custom-optional-footer data {}))
  ([data {:keys [margin-top] :as _props}]
   (text-content/optional-footer data {:resi-v2-custom-style? true
                                       :margin-top    (or margin-top 15)
                                       :margin-bottom 0
                                       :margin-left   0
                                       :paragraph-margin-bottom 0})))

(defn custom-rich-content
  [data]
  (text-content/rich-content data {:resi-v2-custom-style? true}))

(defn image
  [{:keys [data width height]}]
  (let [pdf-image-key (:pdf-image-key data)
        image-value (or pdf-image-key (:image data))]
    (when-not (cu/blank-value? (:image data))
      (card/custom-margins-card
       ""
       [0 0 0 20]
       (cond-> {:image (str image-value)}
         width  (assoc :width width)
         height (assoc :height height))
       (custom-optional-footer data {:margin-top 5})))))

(defn strategy-text
  [data]
  [(card/custom-margins-card
    "Strategy"
    [0 0 0 40]
    (custom-rich-content
     (get-in data [:strategy :rich-content])))])

(defn portfolio-update-text
  [data]
  [(card/custom-margins-card
    "Portfolio Update"
    [0 20 0 30]
    (custom-rich-content
     (get-in data [:portfolio-update-text :rich-content])))])

(defn investment-activity-and-pipeline-text
  [data]
  [(card/custom-margins-card
    "Investment Activity"
    [0 0 0 60]
    (custom-rich-content
     (get-in data
             [:investment-activity-and-pipeline-text :rich-content])))])

(defn performance-and-outlook-text
  [data]
  [(card/custom-margins-card
    "Investments and Major Capex Projects"
    [0 0 0 30]
    (custom-rich-content
     (get-in data [:performance-and-outlook-text :rich-content])))])

(defn esg-summary-text
  [data]
  [(card/custom-margins-card
    "Sustainability Summary"
    [0 20 0 40]
    (custom-rich-content
     (get-in data [:esg-summary-text :rich-content])))])

(defn gresb-text
  [data]
  [(card/custom-margins-card
    "GRESB"
    [0 0 0 20]
    (custom-rich-content
     (get-in data [:gresb-text :rich-content])))])

(defn epc-text
  [data]
  [(card/custom-margins-card
    "Energy Performance Certificates"
    [0 0 0 20]
    (custom-rich-content
     (get-in data [:epc-text :rich-content])))])

(defn eu-taxonomy-text
  [data]
  [(card/custom-margins-card
    "EU Taxonomy Alignment"
    [0 0 0 20]
    (custom-rich-content
     (get-in data [:eu-taxonomy-text :rich-content])))])

(defn green-certificates-text
  [data]
  [(card/custom-margins-card
    "Green Building Certifications"
    [0 0 0 20]
    (custom-rich-content
     (get-in data [:green-certificates-text :rich-content])))])

(defn green-electricity-text
  [data]
  [(card/custom-margins-card
    "Renewable Energy"
    [0 0 0 20]
    (custom-rich-content
     (get-in data [:green-electricity-text :rich-content])))])

(defn esg-investments-text
  [data]
  [(card/custom-margins-card
    "Sustainability Investments"
    [0 0 0 20]
    (custom-rich-content
     (get-in data [:esg-investments-text :rich-content])))])

(defn crrem-pathway-text
  [data]
  [(card/custom-margins-card
    "2040 Climate Net Zero Target"
    [0 0 0 0]
    (custom-rich-content
     (get-in data [:crrem-pathway-text :rich-content])))])

(defn tenant-satisfaction-text
  [data]
  [(card/custom-margins-card
    "Tenant Satisfaction"
    [0 0 0 20]
    (custom-rich-content
     (get-in data [:tenant-satisfaction-text :rich-content])))])

(defn ungc-text
  [data]
  [(card/custom-margins-card
    "Sustainability incidents"
    [0 0 0 0]
    (custom-rich-content
     (get-in data [:ungc-text :rich-content])))])

(defn disclaimer-text
  [data]
  [(card/custom-margins-card
    ""
    [0 20 0 20]
    (custom-rich-content
     (get-in data [:disclaimer-text :rich-content])))])


;; ---------- Tables ----------

(defn fund-summary-table
  [data]
  [(card/custom-margins-card-with-background
    "Fund Summary"
    [0 20 0 40]
    (vertical-table-pdf/table
     (:fund-summary data)
     {:font-size 9
      :even-row-background-color "#F0EEEA"
      :table-widths [260 240]})
    (custom-optional-footer (:fund-summary data)))])

(defn pivot-contacts-data
  [{:keys [rows]}]
  (let [fields   [:title :name :title-2 :email :phone]
        row-data (mapv :row-data rows)
        columns  (apply mapv vector row-data)]
    (into {}
          (map-indexed
           (fn [idx contact-values]
             [(keyword (str "contact-" (inc idx)))
              (zipmap fields contact-values)]))
          columns)))

(defn contact-block
  [image-data {:keys [title name title-2 email phone]}]
  [(image {:data   image-data
           :width  100
           :height 100})
   {:text title  :margin [0 0 0 0] :fontSize 9 :bold true}
   {:text name   :margin [0 2 0 0] :fontSize 9}
   (when-not (cu/blank-value? title-2)
     {:text title-2  :margin [0 2 0 0] :fontSize 9})
   (when-not (cu/blank-value? email)
     {:text email  :margin [0 2 0 0] :fontSize 9})
   (when-not (cu/blank-value? phone)
     {:text phone  :margin [0 2 0 0] :fontSize 9})])

(defn contact-information-1
  [data]
  (let [contact-images (:contact-images data)
        pivoted-data   (pivot-contacts-data
                        {:rows (-> data :contact-information
                                   :figures :rows)})]
    [(card/custom-margins-card
      "Contact Information"
      [0 20 0 20]
      [{:columns
        [{:width     (/ page/page-width-portrait 3)
          :stack     [(contact-block (:contact-1 contact-images)
                                     (:contact-1 pivoted-data))]
          :alignment :center
          :margin    [0 0 30 0]}
         {:width     (/ page/page-width-portrait 3)
          :stack     [(contact-block (:contact-2 contact-images)
                                     (:contact-2 pivoted-data))]
          :alignment :center
          :margin    [0 0 40 0]}
         {:width     (/ page/page-width-portrait 3)
          :stack     [(contact-block (:contact-3 contact-images)
                                     (:contact-3 pivoted-data))]
          :alignment :center
          :margin    [0 0 40 0]}]
        :margin [0 20 0 0]
        :unbreakable true}])]))

(defn valuation-details-table
  [data]
  [(card/custom-margins-card-with-background
    "Legal, Administration and Property Valuation Details"
    [0 20 0 0]
    (vertical-table-pdf/table
     (:valuation-details data)
     {:font-size 9
      :even-row-background-color "#F0EEEA"
      :table-widths [260 240]}))
   (custom-optional-footer (:valuation-details data))])

(defn fund-capital-metrics-table
  [data]
  [(card/custom-margins-card
    "Key Metrics"
    [0 20 0 30]
    (vertical-table-pdf/table (:fund-capital-metrics data)
                              {:title-in-heading? true})
    (custom-optional-footer (:fund-capital-metrics data)))])

(defn fund-kpis-metrics-table
  [data]
  [(card/custom-margins-card
    ""
    [0 0 0 30]
    (vertical-table-pdf/table (:fund-kpis-metrics data)
                              {:title-in-heading? true})
    (custom-optional-footer (:fund-kpis-metrics data)))])

(defn performance-metrics-table
  [data]
  [(card/custom-margins-card
    ""
    [0 0 0 30]
    (vertical-table-pdf/table (:performance-metrics data)
                              {:title-in-heading? true})
    (custom-optional-footer (:performance-metrics data)))])

(defn portfolio-metrics-table
  [data]
  [(card/custom-margins-card
    ""
    [0 0 0 30]
    (vertical-table-pdf/table (:portfolio-metrics data)
                              {:title-in-heading? true})
    (custom-optional-footer (:portfolio-metrics data)))])

(defn fa-icon
  [{:keys [unicode color size]
    :or   {color "#333333" size 11}}]
  {:text     unicode
   :font     "FontAwesome"
   :color    color
   :bold     true
   :fontSize size
   :margin [0 3 0 0]})

(defn trend-indicator-row-fa
  ([]
   (trend-indicator-row-fa {}))
  ([{:keys [text size gap borders? icons]
     :or   {text     "Trend indicator (outlook)"
            size     9
            gap      8
            borders? false
            icons    {:up "\uf062" :down "\uf063" :right "\uf061"}}}]
   (let [gap-node {:width gap :text ""}]
     {:margin [0 10 0 0]
      :table  {:widths ["*"]
               :body
               [[{:fillColor "#F0EEEA"
                  :border    (if borders? [true true true true]
                                         [false false false false])
                  :columns   [{:width  "auto"
                               :columns [(fa-icon {:unicode (:up icons)
                                                   :color   "#2ECC71"
                                                   :size    size})
                                         gap-node
                                         (fa-icon {:unicode (:down icons)
                                                   :color   "#E53935"
                                                   :size    size})
                                         gap-node
                                         (fa-icon {:unicode (:right icons)
                                                   :color   "#9E9E9E"
                                                   :size    size})]}
                              {:text      text
                               :margin    [10 4 0 0]
                               :fontSize  9
                               :color     "#333333"
                               :alignment "left"
                               :width     "*"}]}]]}
      :layout {:defaultBorder false}})))

(defn market-overview-table
  [data]
  [(card/custom-margins-card
    "Hotels Market Snapshot"
    [0 20 0 30]
    (vertical-table-pdf/table (:market-overview data))
    (trend-indicator-row-fa {:size 9 :gap 10 :borders? false})
    (custom-optional-footer (:market-overview data)))])

(defn fund-returns-table
  [data]
  [(card/custom-margins-card
    "Fund Returns in %"
    [0 0 0 0]
    (vertical-table-pdf/table (:fund-returns-table data))
    (custom-optional-footer (:fund-returns-table data)))])

(defn benchmark-index-table
  [data]
  [(card/custom-margins-card
    "Benchmark Index: INREV European ODCE Index, Total Return in %"
    [0 0 0 0]
    (vertical-table-pdf/table (:benchmark-index data))
    (custom-optional-footer (:benchmark-index data)))])

(defn debt-kpis-table
  [data]
  [(card/custom-margins-card
    "Debt KPIs"
    [0 20 0 0]
    (vertical-table-pdf/table (:debt-kpis data))
    (custom-optional-footer (:debt-kpis data)))])

(defn debt-facilities-table
  [data]
  [(card/custom-margins-card
    "Debt Facilities"
    [0 0 0 0]
    (horizontal-table-pdf/table (:debt-facilities data))
    (custom-optional-footer (:debt-facilities data)))])

(defn portfolio-summary-table
  [data]
  [(card/custom-margins-card
    "Portfolio Summary"
    [0 10 0 0]
    (vertical-table-pdf/table (:portfolio-summary data))
    (custom-optional-footer (:portfolio-summary data)))])

(defn acquisitions-table
  [data]
  [(card/custom-margins-card
    "Acquisitions TTM"
    [0 20 0 60]
    (horizontal-table-pdf/table (:acquisitions data)
                                {:font-size 9})
    (custom-optional-footer (:acquisitions data)))])

(defn dispositions-table
  [data]
  [(card/custom-margins-card
    "Dispositions TTM"
    [0 0 0 60]
    (horizontal-table-pdf/table (:dispositions data)
                                {:font-size 9})
    (custom-optional-footer (:dispositions data)))])

(defn gresb-by-year-table
  [data]
  [(card/custom-margins-card
    "Fund GRESB Rating by Year"
    [0 0 0 20]
    (horizontal-table-pdf/table (:gresb-by-year data))
    (custom-optional-footer (:gresb-by-year data)))])

(defn portfolio-epc-table
  [data]
  (let [base   (horizontal-table-pdf/table (:portfolio-epc data))
        merged (epc-table/merge-epc-triangle-into-horizontal-table
                base {:size 7 :cell 10})]
    [(card/custom-margins-card
      "Portfolio EPC"
      [0 0 0 20]
      merged
      (custom-optional-footer (:portfolio-epc data)))]))

(defn green-certs-by-country-table
  [data]
  [(card/custom-margins-card
    "Certifications by Country"
    [0 0 0 20]
    (horizontal-table-pdf/table (:green-certs-by-country data))
    {:columns   [{:width 100
                  :stack [(image {:data (:green-certificate-image-1 data)
                                  :width 50})]
                  :alignment :center
                  :margin [0 20 0 0]}
                 {:width 100
                  :stack [(image {:data (:green-certificate-image-2 data)
                                   :width 100})]
                  :alignment :center
                  :margin [0 20 0 0]}]
     :margin [20 0 0 0]}
    #_#_(image {:data (:green-certificate-image-1 data)
            :width 50})
    (image {:data (:green-certificate-image-2 data)
            :width 100})
    #_(custom-optional-footer (:green-certs-by-country data)))])

(defn share-of-fossil-free-energy-table
  [data]
  [(card/custom-margins-card
    "Share of Renewable Energy"
    [0 0 0 20]
    (horizontal-table-pdf/table (:share-of-fossil-free-energy data))
    (custom-optional-footer (:share-of-fossil-free-energy data)))])

(defn emissions-table
  [data]
  [(card/custom-margins-card
    "Greenhouse Gas Emissions, Operational Carbon"
    [0 0 0 20]
    (horizontal-table-pdf/table (:emissions data))
    {:columns   [{:width 100
                  :stack [(image {:data (:crrem-logo-image data)
                                  :width 75})]
                  :alignment :left
                  :margin [0 0 0 0]}]
     :margin [0 0 0 0]}
    #_(custom-optional-footer (:emissions data)))])

(defn esg-nps-table
  [data]
  [(card/custom-margins-card
    "Overall Satisfaction & NPS"
    [0 0 0 20]
    (horizontal-table-pdf/table (:esg-nps data))
    (custom-optional-footer (:esg-nps data)))])

(defn nav-breakdown-ifrs-table
  [data]
  [(card/custom-margins-card
    "NAV Breakdown IFRS to INREV Bridge, €"
    [0 20 0 20]
    (vertical-table-pdf/table (:nav-breakdown-ifrs data))
    (custom-optional-footer (:nav-breakdown-ifrs data)))])

(defn nav-breakdown-inrev-table
  [data]
  [(card/custom-margins-card
    "NAV Breakdown (INREV), €"
    [0 20 0 20]
    (vertical-table-pdf/table (:nav-breakdown-inrev data))
    (custom-optional-footer (:nav-breakdown-inrev data)))])

(defn income-statement-table
  [data]
  [(card/custom-margins-card
    "Consolidated Statement of Comprehensive Income (INREV), €"
    [0 20 0 20]
    (vertical-table-pdf/table (:income-statement data))
    (custom-optional-footer (:income-statement data)))])

(defn financial-positions-statement-table-1
  [data]
  [(card/custom-margins-card
    "Consolidated Statement of Financial Positions (INREV), €"
    [0 20 0 20]
    (vertical-table-pdf/table (:financial-positions-statement-1 data))
    (custom-optional-footer (:financial-positions-statement-1 data)))])

(defn financial-positions-statement-table-2
  [data]
  [(card/custom-margins-card
    "Consolidated Statement of Financial Positions (INREV), €"
    [0 20 0 20]
    (vertical-table-pdf/table (:financial-positions-statement-2 data))
    (custom-optional-footer (:financial-positions-statement-2 data)))])

(defn cash-flows-statement-table-1
  [data]
  [(card/custom-margins-card
    "Consolidated Statement of Cash Flows (INREV), €"
    [0 20 0 20]
    (vertical-table-pdf/table (:cash-flows-statement-1 data))
    (custom-optional-footer (:cash-flows-statement-1 data)))])

(defn cash-flows-statement-table-2
  [data]
  [(card/custom-margins-card
    "Consolidated Statement of Cash Flows (INREV), €"
    [0 20 0 20]
    (vertical-table-pdf/table (:cash-flows-statement-2 data))
    (custom-optional-footer (:cash-flows-statement-2 data)))])

;; NOTE: glossary now rendered via dynamic-horizontal-table-pages in glossary-page

;; ---------- Charts ----------

(defn nav-per-unit-svg
  [data]
  (let [figures (-> data :nav-per-unit :figures)
        y-axis (:yAxis figures)
        custom-y-axis (assoc (first y-axis) 
                             :max 1.5
                             :min 0
                             :tickInterval 0.1)
        cfg     (assoc {:chart  {:width   1000
                                 :height  500
                                 :spacing [0 0 -10 0]
                                 :margin  [0 0 130 80]
                                 :style {:fontSize "21px"
                                         :fontWeight "normal"}}
                        :legend {:verticalAlign "bottom"
                                 :align         "center"
                                 :padding       10}}
                       :yAxis
                       custom-y-axis)]
    [(card/custom-margins-card-with-background
      "NAV per Unit"
      [0 0 0 0]
      {:svg   (chart-view/chart-svg
               "highcharts"
               (potpuri/deep-merge figures cfg))
       :width 530})
     #_(custom-optional-footer
      (:nav-per-unit data))]))

(defn loan-to-gav-svg
  [data]
  (let [figures (-> data :loan-to-gav :figures)
        y-axis (:yAxis figures)
        custom-y-axis (assoc (first y-axis)
                             :max 1
                             :min 0
                             :tickInterval 0.1)
        cfg     (assoc {:chart  {:width   1000
                                 :height  420
                                 :spacing [0 0 50 0]
                                 :margin  [0 0 80 80]
                                 :style {:fontSize "21px"
                                         :fontWeight "normal"}}
                        :legend {:verticalAlign "bottom"
                                 :align         "center"
                                 :padding       10}}
                       :yAxis
                       custom-y-axis)]
    [(card/custom-margins-card-with-background
      "Loan-to-GAV & Loan-to-Value"
      [0 0 0 0]
      {:svg   (chart-view/chart-svg
               "highcharts"
               (potpuri/deep-merge figures cfg))
       :width 530})
     #_(custom-optional-footer
      (:loan-to-gav data))]))

(defn rent-maturities-svg
  [data]
  (let [figures (-> data :rent-maturities :figures)
        cfg     {:chart  {:width   1000
                          :height  500
                          :spacing [0 0 0 0]
                          :margin  [0 0 80 95]
                          :style {:fontSize "21px"
                                  :fontWeight "normal"}}
                 :legend {:verticalAlign "bottom"
                          :align         "center"
                          :padding       10}}]
    [(card/custom-margins-card-with-background
      "Rent Maturities"
      [0 0 0 20]
      {:svg   (chart-view/chart-svg
               "highcharts"
               (potpuri/deep-merge figures cfg))
       :width 530})
     (custom-optional-footer
      (:rent-maturities data))]))

(defn rent-maturities-svg-v3
  [data]
  (let [figures (-> data :rent-maturities :figures)
        cfg     {:chart  {:width   1000
                          :height  500
                          :spacing [0 0 0 0]
                          :margin  [0 80 120 80]
                          :style {:fontSize "21px"
                                  :fontWeight "normal"}}
                 :legend {:verticalAlign "bottom"
                          :align         "center"
                          :padding       10}}]
    [(card/custom-margins-card-with-background
      "Rent Maturities"
      [0 0 0 20]
      {:svg   (chart-view/chart-svg
               "highcharts"
               (potpuri/deep-merge figures cfg))
       :width 530})
     (custom-optional-footer
      (:rent-maturities data))]))

(defn nav-bridge-svg
  [data]
  (let [figures (-> data :nav-bridge :figures)
        cfg     {:chart  {:width   900
                          :height  500
                          :spacing [0 0 0 0]
                          :margin  [0 0 80 80]
                          :style {:fontSize "20px"
                                  :fontWeight "normal"}}
                 :legend {:verticalAlign "bottom"
                          :align         "center"
                          :padding       10}
                 :yAxis  {}}]
    [(card/custom-margins-card-with-background
      "NAV Bridge"
      [0 20 0 0]
      {:svg   (chart-view/chart-svg
               "highcharts"
               (potpuri/deep-merge figures cfg))
       :width 530})
     (custom-optional-footer
      (:nav-bridge data))]))

(defn fair-value-by-country-donut-svg
  ([data] (fair-value-by-country-donut-svg data "Fair Value by Country"))
  ([data card-title]
  (let [col-width (/ page/page-width-portrait 3)
        svg-width (- col-width 50)
        figures   (get-in data [:fair-value-by-country :figures])
        cfg       {:chart       {:width   450
                                 :height  450
                                 :spacing [0 0 -5 0]
                                 :margin  [0 0 60 20]
                                 :style {:fontSize "23px"
                                         :fontWeight "normal"}}
                   :legend      {:verticalAlign "bottom"
                                 :align         "center"
                                 :x             20
                                 :padding       4}
                   :plotOptions {:pie {:size        "95%"
                                       :innerSize   "35%"
                                       :borderWidth 0
                                       :borderColor "transparent"
                                       :dataLabels  {:distance       -25
                                                     :padding 0
                                                     :color          "#FFFFFF"
                                                     :style          {:fontSize   "23px"
                                                                      :textOutline "none"}
                                                     :connectorWidth 0
                                                     :softConnector  false
                                                     :inside true
                                                     :crop           false
                                                     :overflow       "none"}}}}]
    [(card/custom-margins-card-with-background
      card-title
      [0 0 10 10]
      {:svg   (chart-view/chart-svg
               "highcharts"
               (potpuri/deep-merge figures cfg))
       :width svg-width})])))

(defn fair-value-by-location-donut-svg
  ([data] (fair-value-by-location-donut-svg data "Fair Value by Location"))
  ([data card-title]
  (let [col-width (/ page/page-width-portrait 3)
        svg-width (- col-width 50)
        figures   (get-in data [:fair-value-by-location :figures])
        cfg       {:chart       {:width   450
                                 :height  450
                                 :spacing [0 0 -5 0]
                                 :margin  [0 0 60 20]
                                 :style {:fontSize "23px"
                                         :fontWeight "normal"}}
                   :legend      {:verticalAlign "bottom"
                                 :align         "center"
                                 :x             20
                                 :padding       4}
                   :plotOptions {:pie {:size        "95%"
                                       :innerSize   "35%"
                                       :borderWidth 0
                                       :borderColor "transparent"
                                       :dataLabels  {:distance       -25
                                                     :padding 0
                                                     :color          "#FFFFFF"
                                                     :style          {:fontSize   "23px"
                                                                      :textOutline "none"}
                                                     :connectorWidth 0
                                                     :softConnector  false}}}}]
    [(card/custom-margins-card-with-background
      card-title
      [0 0 10 10]
      {:svg   (chart-view/chart-svg
               "highcharts"
               (potpuri/deep-merge figures cfg))
       :width svg-width})])))

(defn fair-value-by-type-donut-svg
  ([data] (fair-value-by-type-donut-svg data "Fair Value by Operator"))
  ([data card-title]
  (let [col-width (/ page/page-width-portrait 3)
        svg-width (- col-width 50)
        figures   (get-in data [:fair-value-by-type :figures])
        cfg       {:chart       {:width   480
                                 :height  480
                                 :spacing [0 0 -5 0]
                                 :margin  [0 0 60 30]
                                 :style {:fontSize "23px"
                                         :fontWeight "normal"}}
                   :legend      {:verticalAlign "bottom"
                                 :align         "right"
                                 :layout        "horizontal"
                                 :itemWidth     235 
                                 :itemDistance 35
                                 :padding       4
                                 :itemStyle          {:fontSize   "18px"
                                                  :textOutline "none"}}
                   :plotOptions {:pie {:size        "90%"
                                       :innerSize   "35%"
                                       :borderWidth 0
                                       :borderColor "transparent"
                                       :dataLabels  {:distance       -25
                                                     :padding 0
                                                     :color          "#FFFFFF"
                                                     :style          {:fontSize   "23px"
                                                                      :textOutline "none"}
                                                     :connectorWidth 0
                                                     :softConnector  false
                                                     :crop           false
                                                     :overflow       "none"}}}}]
    [(card/custom-margins-card-with-background
      card-title
      [0 0 0 10]
      {:svg   (chart-view/chart-svg
               "highcharts"
               (potpuri/deep-merge figures cfg))
       :width svg-width})])))

(defn rooms-by-country-donut-svg
  ([data] (rooms-by-country-donut-svg data "# of Rooms by Country"))
  ([data card-title]
  (let [col-width (/ page/page-width-portrait 3)
        svg-width (- col-width 50)
        figures   (get-in data [:rooms-by-country :figures])
        cfg       {:chart       {:width   450
                                 :height  450
                                 :spacing [0 0 -5 0]
                                 :margin  [0 0 60 20]
                                 :style {:fontSize "23px"
                                         :fontWeight "normal"}}
                   :legend      {:verticalAlign "bottom"
                                 :align         "center"
                                 :x             20
                                 :padding       4}
                   :plotOptions {:pie {:size        "95%"
                                       :innerSize   "35%"
                                       :borderWidth 0
                                       :borderColor "transparent"
                                       :dataLabels  {:distance       -25
                                                     :padding 0
                                                     :color          "#FFFFFF"
                                                     :style          {:fontSize   "23px"
                                                                      :textOutline "none"}
                                                     :connectorWidth 0
                                                     :softConnector  false
                                                     :inside true
                                                     :crop           false
                                                     :overflow       "none"}}}}]
    [(card/custom-margins-card-with-background
      card-title
      [0 0 10 10]
      {:svg   (chart-view/chart-svg
               "highcharts"
               (potpuri/deep-merge figures cfg))
       :width svg-width})])))

(defn rooms-by-location-donut-svg
  ([data] (rooms-by-location-donut-svg data "# of Rooms by Location"))
  ([data card-title]
  (let [col-width (/ page/page-width-portrait 3)
        svg-width (- col-width 50)
        figures   (get-in data [:rooms-by-location :figures])
        cfg       {:chart       {:width   450
                                 :height  450
                                 :spacing [0 0 -5 0]
                                 :margin  [0 0 60 20]
                                 :style {:fontSize "23px"
                                         :fontWeight "normal"}}
                   :legend      {:verticalAlign "bottom"
                                 :align         "center"
                                 :x             20
                                 :padding       4}
                   :plotOptions {:pie {:size        "95%"
                                       :innerSize   "35%"
                                       :borderWidth 0
                                       :borderColor "transparent"
                                       :dataLabels  {:distance       -25
                                                     :padding 0
                                                     :color          "#FFFFFF"
                                                     :style          {:fontSize   "23px"
                                                                      :textOutline "none"}
                                                     :connectorWidth 0
                                                     :softConnector  false}}}}]
    [(card/custom-margins-card-with-background
      card-title
      [0 0 10 10]
      {:svg   (chart-view/chart-svg
               "highcharts"
               (potpuri/deep-merge figures cfg))
       :width svg-width})])))

(defn rooms-by-operator-donut-svg
  ([data] (rooms-by-operator-donut-svg data "# of Rooms by Operator"))
  ([data card-title]
  (let [col-width (/ page/page-width-portrait 3)
        svg-width (- col-width 50)
        figures   (get-in data [:rooms-by-operator :figures])
        cfg       {:chart       {:width   480
                                 :height  480
                                 :spacing [0 0 -5 0]
                                 :margin  [0 0 60 30]
                                 :style {:fontSize "23px"
                                         :fontWeight "normal"}}
                   :legend      {:verticalAlign "bottom"
                                 :align         "right"
                                 :layout        "horizontal"
                                 :itemWidth     235
                                 :itemDistance 35
                                 :padding       4
                                 :itemStyle          {:fontSize   "18px"
                                                      :textOutline "none"}}
                   :plotOptions {:pie {:size        "90%"
                                       :innerSize   "35%"
                                       :borderWidth 0
                                       :borderColor "transparent"
                                       :dataLabels  {:distance       -25
                                                     :padding 0
                                                     :color          "#FFFFFF"
                                                     :style          {:fontSize   "23px"
                                                                      :textOutline "none"}
                                                     :connectorWidth 0
                                                     :softConnector  false
                                                     :crop           false
                                                     :overflow       "none"}}}}]
    [(card/custom-margins-card-with-background
      card-title
      [0 0 0 10]
      {:svg   (chart-view/chart-svg
               "highcharts"
               (potpuri/deep-merge figures cfg))
       :width svg-width})])))

(defn portfolio-noi-and-niy-svg
  [data]
  (let [figures (-> data :portfolio-noi-and-niy :figures)
        cfg     {:chart  {:width   900
                          :height  500
                          :spacing [0 0 -5 0]
                          :margin  [0 80 120 80]
                          :style {:fontSize "20px"
                                  :fontWeight "normal"}}
                 :legend {:verticalAlign "bottom"
                          :align         "center"
                          :padding       10}}]
    [(card/custom-margins-card-with-background
      "Portfolio NOI and NOI Yield"
      [0 20 0 20]
      {:svg   (chart-view/chart-svg
               "highcharts"
               (potpuri/deep-merge figures cfg))
       :width 530})
     (custom-optional-footer
      (:portfolio-noi-and-niy data))]))

(defn valuation-change-svg
  [data]
  (let [figures (-> data :valuation-change :figures)
        cfg     {:chart  {:width   900
                          :height  500
                          :spacing [0 0 0 0]
                          :margin  [0 0 80 80]
                          :style {:fontSize "20px"
                                  :fontWeight "normal"}}
                 :legend {:verticalAlign "bottom"
                          :align         "center"
                          :padding       10}
                 :yAxis  {}}]
    [(card/custom-margins-card-with-background
      "Valuation Change Q-o-Q"
      [0 0 0 0]
      {:svg   (chart-view/chart-svg
               "highcharts"
               (potpuri/deep-merge figures cfg))
       :width 530})
     (custom-optional-footer
      (:valuation-change data))]))

#_(defn annual-carbon-intensity
  [data]
  (let [figures (-> data :annual-carbon-intensity :figures)
        cfg     {:chart  {:width   1280
                          :height  430
                          :spacing [0 0 0 30]
                          :margin  [0 0 100 100]
                          :style {:fontSize "30px"
                                  :fontWeight "normal"}}
                 :legend {:verticalAlign "bottom"
                          :align         "center"
                          :padding       10}}]
    [(card/custom-margins-card
      "Annual Carbon Intensity"
      [0 0 0 10]
      {:svg   (chart-view/chart-svg
               "highcharts"
               (potpuri/deep-merge figures cfg))
       :width 530
       :height 170}
      (custom-optional-footer
       (:annual-carbon-intensity data)))]))

(defn cmrf-towards-net-zero-svg
  [data]
  (let [figures (-> data :cmrf-towards-net-zero :figures)
        cfg     {:chart  {:width   1380
                          :height  580
                          :spacing [0 0 0 30]
                          :margin  [0 0 130 100]
                          :style {:fontSize "30px"
                                  :fontWeight "normal"}}
                 :legend {:verticalAlign "bottom"
                          :align         "center"
                          :padding       10}}]
    [(card/custom-margins-card
      "CMH-II Operational Net Zero by 2035 Pathway (SBTi)"
      [0 -30 0 20]
      {:svg   (chart-view/chart-svg
               "highcharts"
               (potpuri/deep-merge figures cfg))
       :width 530
       :height 280
       :margin [0 -30 0 0]}
      (custom-optional-footer
       (:cmrf-towards-net-zero data)))]))


;; ---------- Pages ----------

(defn fund-summary-page-1
  [data]
  (page/page
   (page/page-title-vertical-layout
    {:fund-name  (:fund-name data)
     :page-title "Fund Summary (1/2)"
     :toc-title "Fund Summary"
     :toc-item   true})
   [(fund-summary-table data)
    (strategy-text data)
    (contact-information-1 data)]))

(defn fund-summary-page-2
  [data]
  (page/page
   (page/page-title-vertical-layout
    {:fund-name  (:fund-name data)
     :page-title "Fund Summary (2/2)"})
   [(valuation-details-table data)]))

(defn quarter-update-page
  [data]
  (page/page
   (page/page-title-vertical-layout
    {:fund-name  (:fund-name data)
     :page-title "Commentary"
     :toc-title "Fund Commentary"
     :toc-item   true})
   [(portfolio-update-text data)
    (performance-and-outlook-text data)
    (investment-activity-and-pipeline-text data)
    {:columns   [{:width (/ page/page-width-portrait 2)
                  :stack [(image {:data  (:quarter-update-image-1 data)
                                  :width (- (/ page/page-width-portrait 2) 25)})]
                  :margin [0 0 0 0]}
                 {:width (- (/ page/page-width-portrait 2) 20)
                  :stack [(image {:data  (:quarter-update-image-2 data)
                                  :width (- (/ page/page-width-portrait 2) 25)})]
                  :margin [-15 0 0 0]}]
     :absolutePosition {:x 20
                        :y 620}}]))

(defn key-metrics-page
  [data]
  (page/page
   (page/page-title-vertical-layout
    {:fund-name  (:fund-name data)
     :page-title "Key Metrics"
     :toc-item   true})
   [(fund-capital-metrics-table data)
    (fund-kpis-metrics-table data)
    (performance-metrics-table data)
    (portfolio-metrics-table data)]))

(defn market-overview-page
  [data]
  (page/page
   (page/page-title-vertical-layout
    {:fund-name  (:fund-name data)
     :page-title "Market Overview"
     :toc-item   true})
   [(market-overview-table data)
    (image {:data   (:market-overview-image data)
            :width  (- page/page-width-portrait 40)})]))

(defn fund-returns-page-1
  [data]
  (page/page
   (page/page-title-vertical-layout
    {:fund-name  (:fund-name data)
     :page-title "Fund Returns (1/2)"
     :toc-title "Fund Returns"
     :toc-item   true})
   [(fund-returns-table data)
    (benchmark-index-table data)
    (nav-per-unit-svg data)]))

(defn fund-returns-page-2
  [data]
  (page/page
   (page/page-title-vertical-layout
    {:fund-name  (:fund-name data)
     :page-title "Fund Returns (2/2)"})
   [(nav-bridge-svg data)]))

(defn debt-financing-page-1
  [data]
  (page/page
   (page/page-title-vertical-layout
    {:fund-name  (:fund-name data)
     :page-title "Debt Financing"
     :toc-title "Debt Financing"
     :toc-item   true})
   [(debt-kpis-table data)
    (debt-facilities-table data)
    (loan-to-gav-svg data)]))

(defn portfolio-summary-page-1
  [data]
  (page/page
   (page/page-title-vertical-layout
    {:fund-name  (:fund-name data)
     :page-title "Portfolio Overview (1/3)"
     :toc-title "Portfolio Overview"
     :toc-item   true})
   [(portfolio-summary-table data)
   {:columns
     [{:width  (- (/ page/page-width-portrait 3) 20) 
       :stack  (fair-value-by-country-donut-svg data)}
      {:width  (- (/ page/page-width-portrait 3) 20)
       :stack  (fair-value-by-location-donut-svg data)}
      {:width  (- (/ page/page-width-portrait 3) 30)
       :stack  (fair-value-by-type-donut-svg data)}]
     :columnGap 15}
    {:columns
     [{:width  (- (/ page/page-width-portrait 3) 20) 
       :stack  (rooms-by-country-donut-svg data)}
      {:width  (- (/ page/page-width-portrait 3) 20)
       :stack  (rooms-by-location-donut-svg data)}
      {:width  (- (/ page/page-width-portrait 3) 30)
       :stack  (rooms-by-operator-donut-svg data)}]
     :columnGap 15}]))

(defn portfolio-summary-page-2
  [data]
  (page/page
   (page/page-title-vertical-layout
    {:fund-name  (:fund-name data)
     :page-title "Portfolio Overview (2/3)"})
   [(portfolio-noi-and-niy-svg data)
    #_(like-for-like-rental-growth-svg data)
    #_(rent-maturities-svg data)
    (rent-maturities-svg data)]))

(defn portfolio-summary-page-2-v3
  [data]
  (page/page
   (page/page-title-vertical-layout
    {:fund-name  (:fund-name data)
     :page-title "Portfolio Overview (2/3)"})
   [(portfolio-noi-and-niy-svg data)
    (rent-maturities-svg-v3 data)]))

(defn portfolio-summary-page-3
  [data]
  (page/page
   (page/page-title-vertical-layout
    {:fund-name  (:fund-name data)
     :page-title "Portfolio Overview (3/3)"})
   [(valuation-change-svg data)]))

(defn investment-activity-page
  [data]
  (page/page
   (page/page-title-vertical-layout
    {:fund-name  (:fund-name data)
     :page-title "Investment Activity"
     :toc-item   true})
   [(acquisitions-table data)
    (dispositions-table data)
    {:columns   [{:width (/ page/page-width-portrait 2)
                  :stack [(image {:data  (:investment-activity-image-1 data)
                                  :width (- (/ page/page-width-portrait 2) 40)})]
                  :margin [0 0 0 0]}
                 {:width (- (/ page/page-width-portrait 2) 40)
                  :stack [(image {:data  (:investment-activity-image-2 data)
                                  :width (- (/ page/page-width-portrait 2) 40)})]
                  :margin [0 0 0 0]}]
     :absolutePosition {:x 20
                        :y 620}}]))

(defn sustainability-page-1
  [data]
  (page/page
   (page/page-title-vertical-layout
    {:fund-name  (:fund-name data)
     :page-title "Sustainability (1/3)"
     :toc-title "Sustainability"
     :toc-item   true})
   [(esg-summary-text data)
    {:columns   [{:width (- (/ page/page-width-portrait 2) 20)
                  :stack (gresb-text data)
                  :margin [0 0 0 20]}
                 {:width (- (/ page/page-width-portrait 2) 100)
                  :stack (gresb-by-year-table data)
                  :margin [20 0 0 20]}
                 {:width (- (/ page/page-width-portrait 3) 20)
                  :stack [(image {:data  (:gresb-logo-image data)
                                   :width 55})]
                  :margin [20 10 0 0]}]}
    {:columns   [{:width (- (/ page/page-width-portrait 2) 20)
                  :stack (epc-text data)
                  :margin [0 0 0 0]}
                 {:width (- (/ page/page-width-portrait 2) 20)
                  :stack (portfolio-epc-table data)
                  :margin [20 0 0 0]}]}
    {:columns   [{:width (- (/ page/page-width-portrait 2) 20)
                  :stack (eu-taxonomy-text data)
                  :margin [0 0 0 0]}
                 {:width (- (/ page/page-width-portrait 2) 20)
                  :stack []
                  :margin [0 0 0 0]}]}]))

(defn sustainability-page-2
  [data]
  (page/page
   (page/page-title-vertical-layout
    {:fund-name  (:fund-name data)
     :page-title "Sustainability (2/3)"})
   [{:columns   [{:width (- (/ page/page-width-portrait 2) 20)
                  :stack (green-certificates-text data)
                  :margin [0 20 0 0]}
                 {:width (- (/ page/page-width-portrait 2) 20)
                  :stack (green-certs-by-country-table data)
                  :margin [20 20 0 0]}]}
    {:columns   [{:width (- (/ page/page-width-portrait 2) 20)
                  :stack (green-electricity-text data)
                  :margin [0 0 0 40]}
                 {:width (- (/ page/page-width-portrait 2) 20)
                  :stack (share-of-fossil-free-energy-table data)
                  :margin [20 0 0 40]}]}
    {:columns   [{:width (- (/ page/page-width-portrait 2) 20)
                  :stack (esg-investments-text data)
                  :margin [0 0 0 40]}
                 {:width (- (/ page/page-width-portrait 2) 20)
                  :stack [(image {:data  (:esg-investments-image data)
                                   :width (- (/ page/page-width-portrait 2) 40)})]
                  :margin [20 0 0 60]}]}
    ]))

(defn sustainability-page-3
  [data]
  (let [crrem-logo-data (:crrem-logo-image data)]
    (page/page
     (page/page-title-vertical-layout
      {:fund-name  (:fund-name data)
       :page-title "Sustainability (3/3)"})
     [{:columns   [{:width (- (/ page/page-width-portrait 2) 20)
                    :stack (crrem-pathway-text data)
                    :margin [0 20 0 (if (cu/blank-value? (:image crrem-logo-data)) 40 0)]}
                   {:width (- (/ page/page-width-portrait 2) 20)
                    :stack (emissions-table data)
                    :margin [20 20 0 (if (cu/blank-value? (:image crrem-logo-data)) 40 0)]}]}
      (cmrf-towards-net-zero-svg data)
      {:columns   [{:width (- (/ page/page-width-portrait 2) 20)
                    :stack (tenant-satisfaction-text data)
                    :margin [0 0 0 10]}
                   {:width (- (/ page/page-width-portrait 2) 20)
                    :stack (esg-nps-table data)
                    :margin [20 0 0 10]}]}
      (ungc-text data)])))

(defn nav-breakdown-ifrs-page
  [data]
  (page/page
   (page/page-title-vertical-layout
    {:fund-name  (:fund-name data)
     :page-title "Financial Statements (1/7)"
     :toc-title "Financial Statements"
     :toc-item   true})
   (nav-breakdown-ifrs-table data)))

(defn nav-breakdown-inrev-page
  [data]
  (page/page
   (page/page-title-vertical-layout
    {:fund-name  (:fund-name data)
     :page-title "Financial Statements (2/7)"})
   (nav-breakdown-inrev-table data)))

(defn income-statement-page
  [data]
  (page/page
   (page/page-title-vertical-layout
    {:fund-name  (:fund-name data)
     :page-title "Financial Statements (3/7)"})
   [(income-statement-table data)]))

(defn financial-positions-statement-page-1
  [data]
  (page/page
   (page/page-title-vertical-layout
    {:fund-name  (:fund-name data)
     :page-title "Financial Statements (4/7)"})
   (financial-positions-statement-table-1 data)))

(defn financial-positions-statement-page-2
  [data]
  (page/page
   (page/page-title-vertical-layout
    {:fund-name  (:fund-name data)
     :page-title "Financial Statements (5/7)"})
   (financial-positions-statement-table-2 data)))

(defn cash-flows-statement-page-1
  [data]
  (page/page
   (page/page-title-vertical-layout
    {:fund-name  (:fund-name data)
     :page-title "Financial Statements (6/7)"})
   (cash-flows-statement-table-1 data)))

(defn cash-flows-statement-page-2
  [data]
  (page/page
   (page/page-title-vertical-layout
    {:fund-name  (:fund-name data)
     :page-title "Financial Statements (7/7)"})
   (cash-flows-statement-table-2 data)))

(defn portfolio-denmark-page
  [data]
  (horizontal-table-pdf/dynamic-horizontal-table-pages
   {:fund-name ""}
   "Denmark"
   (-> data
       :portfolio-denmark)
   {:full-width?    true
    :partition-size 40
    :vertical-layout? true
    :toc-item true
    :page-title "Portfolio"
    :odd-color      (theme/color [:pdf :table :odd-color])
    :even-color     (theme/color [:pdf :table :even-color])
    :heading-color  (theme/color [:pdf :table :heading-color])
    :font-size 6}
   (custom-optional-footer (:portfolio-denmark data))))

(defn portfolio-finland-page
  [data]
  (horizontal-table-pdf/dynamic-horizontal-table-pages
   {:fund-name ""}
   "Finland"
   (-> data
       :portfolio-finland)
   {:full-width?    true
    :partition-size 40
    :vertical-layout? true
    :page-title "Portfolio"
    :odd-color      (theme/color [:pdf :table :odd-color])
    :even-color     (theme/color [:pdf :table :even-color])
    :heading-color  (theme/color [:pdf :table :heading-color])
    :font-size 6}
   (custom-optional-footer (:portfolio-finland data))))

(defn portfolio-norway-page
  [data]
  (horizontal-table-pdf/dynamic-horizontal-table-pages
   {:fund-name ""}
   "Norway"
   (-> data
       :portfolio-norway)
   {:full-width?    true
    :partition-size 40
    :vertical-layout? true
    :page-title "Portfolio"
    :odd-color      (theme/color [:pdf :table :odd-color])
    :even-color     (theme/color [:pdf :table :even-color])
    :heading-color  (theme/color [:pdf :table :heading-color])
    :font-size 6}
   (custom-optional-footer (:portfolio-norway data))))

(defn portfolio-sweden-page
  [data]
  (horizontal-table-pdf/dynamic-horizontal-table-pages
   {:fund-name ""}
   "Sweden"
   (-> data
       :portfolio-sweden)
   {:full-width?    true
    :partition-size 40
    :vertical-layout? true
    :page-title "Portfolio"
    :odd-color      (theme/color [:pdf :table :odd-color])
    :even-color     (theme/color [:pdf :table :even-color])
    :heading-color  (theme/color [:pdf :table :heading-color])
    :font-size 6}
   (custom-optional-footer (:portfolio-sweden data))))

(defn disclaimer-page
  [data]
  (page/page
   (page/page-title-vertical-layout
    {:fund-name  (:fund-name data)
     :page-title "Disclaimer"})
   [(disclaimer-text data)]))

(defn glossary-page
  [data]
  (horizontal-table-pdf/dynamic-horizontal-table-pages
   {:fund-name ""}
   "Glossary"
   (-> data :glossary)
   {:full-width?    true
    :partition-size 35
    :vertical-layout? true
    :toc-item true
    :page-title "Glossary"
    :odd-color      (theme/color [:pdf :table :odd-color])
    :even-color     (theme/color [:pdf :table :even-color])
    :heading-color  (theme/color [:pdf :table :heading-color])
    :font-size 7.5}
   (custom-optional-footer (:glossary data))))

(defn diagonal-band 
  [{:keys [width band-height angle-deg y svg-height]}]
  (let [h        (or svg-height (* band-height 2))
        cx       (/ width 2)
        cy       (or y (/ h 2))
        rect-w   (* width 3)
        rect-h   band-height
        vb       (str "0 0 " width " " h)]
    (rs/render-to-static-markup
     [:svg {:width width :height h :viewBox vb}
      [:g {:transform (str "rotate(" angle-deg " " cx " " cy ")")}
       [:rect {:x (- cx (/ rect-w 2))
               :y (- cy (/ rect-h 2))
               :width rect-w
               :height rect-h
               :fill "#ffffff"
               :stroke "none"}]]])))

(defn opaque-overlay
  [{:keys [width height color opacity]
    :or   {color "#000000"
           opacity 0.65}}]
  (let [vb (str "0 0 " width " " height)]
    (rs/render-to-static-markup
     [:svg {:width width :height height :viewBox vb}
      [:rect {:x 0
              :y 0
              :width  width
              :height height
              :fill   color
              :fill-opacity opacity
              :stroke "none"}]])))

(defn rounded-rect-svg
  [{:keys [width height radius fill opacity]
    :or   {radius 16 fill "#000000" opacity 0.75}}]
  (let [vb (str "0 0 " width " " height)]
    (rs/render-to-static-markup
     [:svg {:width width :height height :viewBox vb}
      [:rect {:x 0 :y 0 :width width :height height
              :rx radius :ry radius
              :fill fill :fill-opacity opacity
              :stroke "none"}]])))

(defn toc-page
  [{:keys [report-data]}]
  (let [line-height 1.35
        page-w 595
        page-h 842
        bg-x 0
        bg-y 90
        bg-h (- page-h bg-y 45)
        cover-image-data (:pdf-cover-image report-data)
        toc-image-data (:pdf-toc-image report-data)
        cover-image (when-not (cu/blank-value? (:image cover-image-data))
                      (or (:pdf-image-key cover-image-data)
                          (:image cover-image-data)))
        toc-image (when-not (cu/blank-value? (:image toc-image-data))
                    (or (:pdf-image-key toc-image-data)
                        (:image toc-image-data)))
        box-x 55
        box-y 200
        box-w 485
        box-h 430
        inner-x (+ box-x 35)
        inner-y (+ box-y 45)
        toc-title (or (:reporting-period report-data) "")]
    [(page/page
      "TOC"
      {:stack [(when-not (cu/blank-value? cover-image)
                 {:absolutePosition {:x 0 :y 0}
                  :image (when-not (cu/blank-value? cover-image) cover-image)
                  :width 595 :height 842})
               {:svg (diagonal-band {:width 595 :band-height 500 :angle-deg -15 :y 750})
                :absolutePosition {:x 0 :y 100}}
               {:text     (str (or (:reporting-period report-data) "") " Fund Report")
                :fontSize 45 :font "MarlideDisplay"
                :absolutePosition {:x 252 :y 680} :color "black"}
               {:text     (-> report-data :fund-name (or "") clojure.string/upper-case)
                :fontSize 15
                :absolutePosition {:x 380 :y 750}
                :color "black"}
               {:absolutePosition {:x 480 :y 780}
                :svg theme/capman-logo-black-svg :fit [80 40]}]})
     (page/page
      nil
      {:stack [;; BG image
               (when-not (cu/blank-value? toc-image)
                 {:absolutePosition {:x bg-x :y bg-y}
                  :image toc-image
                  :width page-w :height bg-h})

               ;; Title band
               (page/page-title-vertical-layout
                {:page-title "Contents"
                 :toc-item   false})

               ;; Dark rounded box
               {:absolutePosition {:x box-x :y box-y}
                :svg (rounded-rect-svg {:width box-w
                                        :height box-h
                                        :radius 18
                                        :fill "#111111"
                                        :opacity 0.85})}

               ;; Reporting period and header
               {:absolutePosition {:x inner-x :y inner-y}
                :text toc-title
                :fontSize 36
                :color "#FFFFFF"
                :font "MarlideDisplay"}
               {:absolutePosition {:x inner-x :y (+ inner-y 45)}
                :text "Table of Contents"
                :fontSize 18
                :color "#FFFFFF"}
               {:absolutePosition {:x inner-x :y (+ inner-y 70)}
                :canvas [{:type "line" :x1 0 :y1 0 :x2 360 :y2 0
                          :lineWidth 1 :lineColor "#FFFFFF"}]}

               ;; TOC list
               {:absolutePosition {:x inner-x :y (+ inner-y 90)}
                :columns [{:color "#FFFFFF"
                           :lineHeight line-height
                           :toc {}
                           :fontSize 11
                           :width (- box-w 80)}]}]})]))

(defn appendix-page
  [report-data]
  (let [bg-x              0
        bg-y              0
        page-w            595
        page-h            842
        bg-h              page-h
        toc-image-data (:pdf-toc-image report-data)
        toc-image (when-not (cu/blank-value? (:image toc-image-data))
                    (or (:pdf-image-key toc-image-data)
                        (:image toc-image-data)))]
    (page/page
     nil
     {:stack [(when-not (cu/blank-value? toc-image)
                {:absolutePosition {:x 0 :y 0}
                 :image toc-image
                 :width 595 :height 842})
              {:absolutePosition {:x bg-x :y bg-y}
               :svg (opaque-overlay {:width page-w :height bg-h
                                     :color "#ffffff" :opacity 0.55})}
              {:svg (diagonal-band {:width 595 :band-height 500 :angle-deg -15 :y 750})
               :absolutePosition {:x 0 :y 100}}
              {:text     "Appendix"
               :fontSize 45 :font "MarlideDisplay"
               :absolutePosition {:x 415 :y 700} :color "black"}
              {:absolutePosition {:x 480 :y 780}
               :svg theme/capman-logo-black-svg :fit [80 40]}]})))


(defn snapshot-element [entries image-key]
  (let [single-entry? (= 1 (count entries))]
    {:margin [0 0 0 0]
     :table {:widths [40 220]
             :body
             [[{:image image-key
                :fit [40 40]
                :alignment :center
                :valign :middle
                :margin [0 -1.5 0 -1.5]
                :border [false false false false]
                :fillColor "#F0EEEA"} 
               (if single-entry?
                 (let [{:keys [row-data default-label]} (first entries)
                       value-str (first (:row-data row-data))]
                   {:stack [{:text value-str
                             :fontSize 11
                             :bold true
                             :margin [0 10 0 -5]}
                            {:text (or (:row-key row-data) default-label)
                             :fontSize 10
                             :margin [0 0 0 0]}]
                    :alignment :left
                    :valign :middle
                    :fillColor "#F0EEEA"
                    :border [true true true true]
                    :margin [0 -1.5 0 0]})
                 {:table {:widths ["auto" "*"]
                          :body (mapv (fn [{:keys [row-data default-label]}]
                                        (let [value-str (first (:row-data row-data))]
                                          [{:text value-str
                                            :fontSize 11
                                            :bold true
                                            :margin [0 2 5 -2]
                                            :lineHeight 1.0
                                            :border [false false false false]}
                                           {:text (or (:row-key row-data) default-label)
                                            :fontSize 10
                                            :margin [-8 2 0 -2]
                                            :lineHeight 1.0
                                            :border [false false false false]}]))
                                      entries)}
                  :layout "noBorders"
                  :fillColor "#F0EEEA"
                  :margin [0 3 0 0]
                  :valign :middle
                  :border [false false false false]})]]}
     :layout "noBorders"}))


(defn portfolio-snapshot-pdf [snapshot-data]
  (let [rows (-> snapshot-data :figures :data)
        elements [(snapshot-element [{:row-data (nth rows 0) :default-label "properties"}] "PROPERTIES")
                  (snapshot-element [{:row-data (nth rows 4) :default-label "rooms"}] "ROOMS")
                  (snapshot-element [{:row-data (nth rows 1) :default-label "WAULT"}] "WAULT")
                  (snapshot-element [{:row-data (nth rows 5) :default-label "of GAV in metropolitan cities"}] "OF GAV IN METROPOLITAN CITIES") 
                  (snapshot-element [{:row-data (nth rows 2) :default-label "Revenue per available room"}] "REVENUE PER AVAILABLE ROOM")
                  (snapshot-element [{:row-data (nth rows 6) :default-label "NOI"}] "NOI")
                  (snapshot-element [{:row-data (nth rows 3) :default-label "NIY"}] "NIY")
                  (snapshot-element [{:row-data (nth rows 7) :default-label "of portfolio income-generating"}] "OF PORTFOLIO INCOME-GENERATING")]

        rows-of-columns (->> elements
                             (partition-all 2)
                             (map (fn [cols]
                                    {:columns cols
                                     :columnGap 20
                                     :margin [0 10 0 0]})))]

    (card/custom-margins-card
     "Portfolio Snapshot"
     [0 20 0 70]
     {:stack rows-of-columns})))


(defn financial-snapshot-pdf [snapshot-data]
  (let [rows (-> snapshot-data :figures :data)
        elements [(snapshot-element [{:row-data (nth rows 0) :default-label "GAV"}
                                     {:row-data (nth rows 1) :default-label "NAV"}] "GAV")
                  (snapshot-element [{:row-data (nth rows 4) :default-label "total return (TTM)"}] "TOTAL RETURN (TTM)")
                  (snapshot-element [{:row-data (nth rows 2) :default-label "LTGAV"}
                                     {:row-data (nth rows 3) :default-label "LTV"}] "LTGAV")
                  (snapshot-element [{:row-data (nth rows 5) :default-label "distribution yield on NAV (TTM)"}] "DISTRIBUTION YIELD ON NAV (TTM)")]

        rows-of-columns (->> elements
                             (partition-all 2)
                             (map (fn [cols]
                                    {:columns cols
                                     :columnGap 20
                                     :margin [0 10 0 0]})))]

    (card/custom-margins-card
     "Financial Snapshot"
     [0 0 0 70]
     {:stack rows-of-columns})))

(defn esg-snapshot-pdf [snapshot-data]
  (let [rows (-> snapshot-data :figures :data)
        elements [(snapshot-element [{:row-data (nth rows 3) :default-label "GRESB, Standing investment benchmark" :formatter nil}] "GRESB, STANDING INVESTMENT BENCHMARK")
                  (snapshot-element [{:row-data (nth rows 0) :default-label "EU taxonomy alignment"}] "EU TAXONOMY ALIGNMENT")
                  (snapshot-element [{:row-data (nth rows 1) :default-label "of properties hold a green building certification"}] "OF PROPERTIES HOLD A GREEN BUILDING CERTIFICATION")
                  (snapshot-element [{:row-data (nth rows 2) :default-label "KgCO2e/m², operational GHG emissions"}] "KGCO2E/M², OPERATIONAL GHG EMISSIONS")]

        rows-of-columns (->> elements
                             (partition-all 2)
                             (map (fn [cols]
                                    {:columns cols
                                     :columnGap 20
                                     :margin [0 10 0 0]})))]

    (card/custom-margins-card
     "Sustainability Snapshot"
     [0 0 0 20] 
     {:stack rows-of-columns})))

(defn fund-snapshot-page
  [data]
  (page/page
   (page/page-title-vertical-layout
    {:fund-name  (:fund-name data)
     :page-title "Fund Snapshot"
     :toc-item   true})
   [(portfolio-snapshot-pdf (:portfolio-snapshot data))
    (financial-snapshot-pdf (:financial-snapshot data))
    (esg-snapshot-pdf (:esg-snapshot data))]))

(defn fund-pages
  [data]
  (concat
   (toc-page {:cover-image :front-page-image
                   :report-data data})
   
   [(fund-summary-page-1 data)]
   [(fund-summary-page-2 data)]

   [(key-metrics-page data)]

   [(fund-snapshot-page data)] ;;TODO

   [(quarter-update-page data)]

   [(market-overview-page data)]

   [(fund-returns-page-1 data)]
   [(fund-returns-page-2 data)]

   [(debt-financing-page-1 data)]
   
   [(portfolio-summary-page-1 data)]
   [(portfolio-summary-page-2 data)]
   [(portfolio-summary-page-3 data)]

   [(investment-activity-page data)]

   ;; ESG
   [(sustainability-page-1 data)]
   [(sustainability-page-2 data)]
   [(sustainability-page-3 data)]

   ;; financial statements
   [(nav-breakdown-ifrs-page data)]
   [(nav-breakdown-inrev-page data)]
   [(income-statement-page data)]
   [(financial-positions-statement-page-1 data)]
   [(financial-positions-statement-page-2 data)]
   [(cash-flows-statement-page-1 data)]
   [(cash-flows-statement-page-2 data)]

   [(appendix-page data)]

   ;; country portfolios
   (portfolio-denmark-page data)
   (portfolio-finland-page data)
   (portfolio-norway-page data)
   (portfolio-sweden-page data)
   
   (glossary-page data)

   [(disclaimer-page data)]))

;; ---- Hotels v3 ----
;; v3 reuses every v2 page except the three below, which differ only in the
;; titles they render. The donut titles come from the editor when set.

(defn portfolio-summary-page-1-v3
  [data]
  (page/page
   (page/page-title-vertical-layout
    {:fund-name  (:fund-name data)
     :page-title "Portfolio Overview (1/3)"
     :toc-title "Portfolio Overview"
     :toc-item   true})
   [(portfolio-summary-table data)
    {:columns
     [{:width  (- (/ page/page-width-portrait 3) 20)
       :stack  (fair-value-by-country-donut-svg
                data
                (custom-title data :fair-value-by-country "Fair Value by Country"))}
      {:width  (- (/ page/page-width-portrait 3) 20)
       :stack  (fair-value-by-location-donut-svg
                data
                (custom-title data :fair-value-by-location "Fair Value by Location"))}
      {:width  (- (/ page/page-width-portrait 3) 30)
       :stack  (fair-value-by-type-donut-svg
                data
                (custom-title data :fair-value-by-type "Fair Value by Operator"))}]
     :columnGap 15}
    {:columns
     [{:width  (- (/ page/page-width-portrait 3) 20)
       :stack  (rooms-by-country-donut-svg
                data
                (custom-title data :rooms-by-country "% of Rooms by Country"))}
      {:width  (- (/ page/page-width-portrait 3) 20)
       :stack  (rooms-by-location-donut-svg
                data
                (custom-title data :rooms-by-location "% of Rooms by Location"))}
      {:width  (- (/ page/page-width-portrait 3) 30)
       :stack  (rooms-by-operator-donut-svg
                data
                (custom-title data :rooms-by-operator "% of Rooms by Operator"))}]
     :columnGap 15}]))

(defn investment-activity-page-v3
  [data]
  (page/page
   (page/page-title-vertical-layout
    {:fund-name  (:fund-name data)
     :page-title "Investment Activity"
     :toc-item   true})
   [(card/custom-margins-card
     "Acquisitions"
     [0 20 0 60]
     (horizontal-table-pdf/table (:acquisitions data)
                                 {:font-size 9})
     (custom-optional-footer (:acquisitions data)))
    (card/custom-margins-card
     "Dispositions"
     [0 0 0 60]
     (horizontal-table-pdf/table (:dispositions data)
                                 {:font-size 9})
     (custom-optional-footer (:dispositions data)))
    {:columns   [{:width (/ page/page-width-portrait 2)
                  :stack [(image {:data  (:investment-activity-image-1 data)
                                  :width (- (/ page/page-width-portrait 2) 40)})]}
                 {:width (/ page/page-width-portrait 2)
                  :stack [(image {:data  (:investment-activity-image-2 data)
                                  :width (- (/ page/page-width-portrait 2) 40)})]}]
     :columnGap 10
     :margin    [0 20 0 0]}]))

(defn glossary-page-v3
  [data]
  (horizontal-table-pdf/dynamic-horizontal-table-pages
   {:fund-name ""}
   ;; The page title already says "Glossary", so the table has no heading.
   nil
   (-> data :glossary)
   {:full-width?    true
    :partition-size 35
    :vertical-layout? true
    :toc-item true
    :page-title "Glossary"
    :odd-color      (theme/color [:pdf :table :odd-color])
    :even-color     (theme/color [:pdf :table :even-color])
    :heading-color  (theme/color [:pdf :table :heading-color])
    :font-size 7.5}
   (custom-optional-footer (:glossary data))))

(defn fund-pages-v3
  [data]
  (concat
   (toc-page {:cover-image :front-page-image
              :report-data data})

   [(fund-summary-page-1 data)]
   [(fund-summary-page-2 data)]

   [(key-metrics-page data)]

   [(fund-snapshot-page data)]

   [(quarter-update-page data)]

   [(market-overview-page data)]

   [(fund-returns-page-1 data)]
   [(fund-returns-page-2 data)]

   [(debt-financing-page-1 data)]

   [(portfolio-summary-page-1-v3 data)]
   [(portfolio-summary-page-2-v3 data)]
   [(portfolio-summary-page-3 data)]

   [(investment-activity-page-v3 data)]

   ;; ESG
   [(sustainability-page-1 data)]
   [(sustainability-page-2 data)]
   [(sustainability-page-3 data)]

   ;; financial statements
   [(nav-breakdown-ifrs-page data)]
   [(nav-breakdown-inrev-page data)]
   [(income-statement-page data)]
   [(financial-positions-statement-page-1 data)]
   [(financial-positions-statement-page-2 data)]
   [(cash-flows-statement-page-1 data)]
   [(cash-flows-statement-page-2 data)]

   [(appendix-page data)]

   ;; country portfolios
   (portfolio-denmark-page data)
   (portfolio-finland-page data)
   (portfolio-norway-page data)
   (portfolio-sweden-page data)

   (glossary-page-v3 data)

   [(disclaimer-page data)]))
